import React from 'react';
import moment from 'moment';
import Modal from 'app/components/Modal';
import { ReactComponent as JPGIcon } from 'assets/icons/extensions/jpeg.svg';
import { formatBytes } from 'app/utils/file';
import classes from './ESignModal.module.scss';

const ESignModal = ({ opened, onClose, signObj = null }) => {
  const isFile = signObj?.eSignatureType === 'file';
  const tDate = signObj?.eSignatureFile?.createdAt || '';
  const tUrl = signObj?.eSignatureFile?.url || '';

  return (
    <Modal
      open={opened}
      onCancel={onClose}
      footer={null}
      className={classes.modalWrapper}
    >
      <div className={classes.modalContent}>
        <p>E-signature</p>
        <div className={classes.signBlock}>
          <span>Signature</span>
          <img src={tUrl} alt="sign" />
        </div>
        <div className={classes.info}>
          <div className={classes.signDate}>
            {/* TODO: need to display signature date */}
            {/* <span>Signature Date:22 May 2024 12:17</span> */}
            <span>Signature Date: {tDate ? moment(tDate).format('DD MMMM YYYY HH:mm') : ''}</span>
          </div>
          {!!isFile && (
            <div className={classes.uploadedFile}>
              <JPGIcon />
              <div>
                <span>{signObj?.eSignatureFile?.fileName}</span>
                <span>{formatBytes(signObj?.eSignatureFile?.fileSize)}</span>
              </div>
            </div>
          )}
          <div>
            <span>Name:</span>
            <span>{signObj?.signerName || ''}</span>
          </div>
          <div>
            <span>Title:</span>
            <span>{signObj?.signerTitle || ''}</span>
          </div>
          <div>
            <span>Company Name:</span>
            <span>{signObj?.signerCompany || ''}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ESignModal;